// Hardcoded translations for existing activities
// จากรูปที่ผู้ใช้ส่งมา

// Static center activities translations (for homepage cards)
export const centerActivitiesData = [
  {
    id: 1,
    titleTh: "กิจกรรมกวักน้องมาเรียน",
    titleEn: "Invite Students Back to School Program",
    descriptionTh: "กิจกรรมที่มีความมุ่งหมายที่จะช่วยลดเด็กเสี่ยงหลุดจากระบบ และดึงเด็กที่หลุดจากระบบกลับมาเรียนในระบบการศึกษาเพื่อโอกาสของอนาคตเด็กให้ได้",
    descriptionEn: "A program aimed at helping reduce at-risk students from dropping out of the education system and bringing back those who have already dropped out to give them opportunities for their future."
  },
  {
    id: 2,
    titleTh: "กิจกรรมพ้นวิกฤติ",
    titleEn: "Crisis Relief Program",
    descriptionTh: "กิจกรรมที่นำวัสดุต่างๆไปช่วยซ่อมแซมปรับปรุงที่อยู่อาศัยที่อยู่ในภาวะวิกฤติ ที่อาจมีผลต่อคุณภาพชีวิต ไปจนถึงเสี่ยงอันตรายต่อชีวิต โดยวัสดุที่นำไปทำมีทั้งวัสดุเหลือใช้ วัสดุที่ได้รับบริจาคมาต่างๆ",
    descriptionEn: "A program that brings various materials to repair and improve housing in critical condition that may affect quality of life or even pose life-threatening dangers, using leftover materials and donated materials."
  },
  {
    id: 3,
    titleTh: "กิจกรรมแบ่งต่อเรนเจอร์",
    titleEn: "Sharing Rangers Program",
    descriptionTh: "กิจกรรมที่จะไปสร้างแรงบันดาลใจให้เด็กๆตามโรงเรียน ซ่อมแซมพื้นที่ในโรงเรียนให้พร้อมใช้งาน และกิจกรรมที่ไปสร้างกำลังใจให้ผู้คนต่างๆ เช่น กิจกรรมรดน้ำดำหัวดิลิเวอร์รี่, กิจกรรมซานต้า is you",
    descriptionEn: "A program that inspires students at schools, repairs school facilities to make them ready for use, and activities that encourage various people, such as Songkran water pouring for delivery riders and Santa is You activities."
  },
  {
    id: 4,
    titleTh: "กิจกรรมกล่องช่วยหมอ",
    titleEn: "Helping Doctors Box Program",
    descriptionTh: "กิจกรรมที่สร้างทีมอาสาสมัครช่วยกันผลิตของจากวัสดุต่างๆมาส่งให้ทีมแพทย์ เช่น ถุงสวมเท้าชุด ppe, ถักปลอกมือกันคนไข้ดึงสายน้ำเกลือ, ถุงใส่สายฟอกไต",
    descriptionEn: "A program that creates volunteer teams to help produce items from various materials to send to medical teams, such as PPE suit shoe covers, knitted arm protectors to prevent patients from pulling out IV lines, and dialysis line bags."
  },
  {
    id: 5,
    titleTh: "กิจกรรมต้นปันใจ",
    titleEn: "Plant Sharing Hearts Program",
    descriptionTh: "กิจกรรมที่ให้อาสาช่วยจัดหากระถางต้นไม้ และต้นไม้เล็กๆเพื่อเพ้นท์และส่งต่อให้กลุ่มผู้ป่วยในแผนกจิตเวช",
    descriptionEn: "A program where volunteers help gather plant pots and small plants to paint and send to psychiatric ward patient groups."
  },
  {
    id: 6,
    titleTh: "กิจกรรมห้องดนตรีแบ่งต่อ",
    titleEn: "Sharing Music Room Program",
    descriptionTh: "กิจกรรมที่รวบรวมเครื่องดนตรี อุปกรณ์ดนตรี ไปสร้างห้องเรียนดนตรีให้โรงเรียนที่มีครูดนตรีแต่ไม่มีอุปกรณ์ดนตรีในการใช้สอนเด็ก",
    descriptionEn: "A program that collects musical instruments and equipment to create music classrooms for schools that have music teachers but lack musical instruments for teaching students."
  },
  {
    id: 7,
    titleTh: "กิจกรรม recycle run",
    titleEn: "Recycle Run Program",
    descriptionTh: "กิจกรรมจัดวิ่งระดมทุนค่าจัดการ บริหารงานศูนย์แบ่งต่อ และค่าจัดส่งวัสดุอุปกรณ์ต่างๆให้นักเรียนยากจน โดยถ้วยรางวัลและเหรียญรางวัลจะใช้เป็นวัสดุรีไซเคิลทั้งมดเพื่อแสดงให้เห็นการนำของกลับมาใช้ใหม่",
    descriptionEn: "A running event to raise funds for management and operations of the Sharing Center and for shipping materials and equipment to underprivileged students, with trophies and medals made entirely from recycled materials to demonstrate reuse."
  },
  {
    id: 8,
    titleTh: "กิจกรรม mirror chance talent",
    titleEn: "Mirror Chance Talent Program",
    descriptionTh: "กิจกรรมจัดประกวดความสามารถเด็กพิการเพื่อสร้างกำลังใจและเปิดโอกาสให้เด็กๆได้มีโอกาสได้แสดงออก",
    descriptionEn: "A talent competition program for children with disabilities to encourage them and provide opportunities for them to express themselves."
  },
  {
    id: 9,
    titleTh: "กิจกรรมฝากยิ้มกลับบ้าน",
    titleEn: "Send Smiles Home Program",
    descriptionTh: "กิจกรรมที่นำตุ๊กตาไปแจกให้พนักงานโรงงานเพื่อนำกลับไปฝากลูกหลานได้ มีข้อม้ต้องกลับไปยิ้มให้ครอบครัว 1 ครั้ง เป็นกิจกรรมที่ต้องการให้ตระหนักเรื่องอย่าลืมพูดคุยและยิ้มให้ครอบครัว เพื่อลดอัตราความรุนแรงในครอบครัวในอนาคต",
    descriptionEn: "A program that distributes dolls to factory workers to take home to their children and grandchildren with the condition that they must smile to their family at least once. This program aims to raise awareness about not forgetting to talk and smile with family to reduce domestic violence rates in the future."
  },
  {
    id: 10,
    titleTh: "กิจกรรมตาต่อตา",
    titleEn: "Eye to Eye Program",
    descriptionTh: "กิจกรรมที่ไปแจกแว่นสายตาให้ผู้สูงอายุในชุมชน",
    descriptionEn: "A program that distributes eyeglasses to elderly people in communities."
  },
  {
    id: 11,
    titleTh: "ธนาคารโอกาส",
    titleEn: "Opportunity Bank",
    descriptionTh: "กิจกรรมที่ร่วมกับทาง กสศ ในการสร้างโอกาสด้านการศึกษาให้เด็กๆ ทั้งการส่งอุปกรณ์ ประสานงานร.ร.ต่างๆให้นักเรียนได้เข้าเรียน",
    descriptionEn: "A program in collaboration with OVEC (Office of the Vocational Education Commission) to create educational opportunities for children by sending equipment and coordinating with various schools to allow students to attend classes."
  },
  {
    id: 12,
    titleTh: "กิจกรรมถนนครูเดิน",
    titleEn: "Teachers Walk the Streets Program",
    descriptionTh: "กิจกรรมที่ผลักดันขับเคลื่อนเชิงนโยบายด้านการศึกษาเรื่องการจัดสรรงบประมาณที่ขาดแคลนใน ร.ร.ขนาดเล็ก ร.ร.พื้นที่สูง และห่างไกล",
    descriptionEn: "A program that drives educational policy initiatives regarding the budget shortage in small schools, highland schools, and remote schools."
  },
  {
    id: 13,
    titleTh: "ส่งของบริจาคให้หน่วยงานและเคสขอความช่วยเหลือทั่วประเทศ",
    titleEn: "Donate Items to Organizations and Cases Requesting Help Nationwide",
    descriptionTh: "",
    descriptionEn: "A program that sends donated items to organizations and assistance cases across the country."
  }
];

export const activityTranslations = {
  // กิจกรรมกวักน้องมาเรียน
  "กิจกรรมกวักน้องมาเรียน": {
    name: "Invite Students Back to School Program",
    description: "A program aimed at helping reduce at-risk students from dropping out of the education system and bringing back those who have already dropped out to give them opportunities for their future."
  },

  // กิจกรรมพ้นวิกฤติ
  "กิจกรรมพ้นวิกฤติ": {
    name: "Crisis Relief Program",
    description: "A program that brings various materials to repair and improve housing in critical condition that may affect quality of life or even pose life-threatening dangers, using leftover materials and donated materials."
  },

  // กิจกรรมแบ่งต่อเรนเจอร์
  "กิจกรรมแบ่งต่อเรนเจอร์": {
    name: "Sharing Rangers Program",
    description: "A program that inspires students at schools, repairs school facilities to make them ready for use, and activities that encourage various people, such as Songkran water pouring for delivery riders and Santa is You activities."
  },

  // กิจกรรมกล่องช่วยหมอ
  "กิจกรรมกล่องช่วยหมอ": {
    name: "Helping Doctors Box Program",
    description: "A program that creates volunteer teams to help produce items from various materials to send to medical teams, such as PPE suit shoe covers, knitted arm protectors to prevent patients from pulling out IV lines, and dialysis line bags."
  },

  // กิจกรรมต้นปันใจ
  "กิจกรรมต้นปันใจ": {
    name: "Plant Sharing Hearts Program",
    description: "A program where volunteers help gather plant pots and small plants to paint and send to psychiatric ward patient groups."
  },

  // กิจกรรมห้องดนตรีแบ่งต่อ
  "กิจกรรมห้องดนตรีแบ่งต่อ": {
    name: "Sharing Music Room Program",
    description: "A program that collects musical instruments and equipment to create music classrooms for schools that have music teachers but lack musical instruments for teaching students."
  },

  // กิจกรรม recycle run
  "กิจกรรม recycle run": {
    name: "Recycle Run Program",
    description: "A running event to raise funds for management and operations of the Sharing Center and for shipping materials and equipment to underprivileged students, with trophies and medals made entirely from recycled materials to demonstrate reuse."
  },

  // กิจกรรม mirror chance talent
  "กิจกรรม mirror chance talent": {
    name: "Mirror Chance Talent Program",
    description: "A talent competition program for children with disabilities to encourage them and provide opportunities for them to express themselves."
  },

  // กิจกรรมฝากยิ้มกลับบ้าน
  "กิจกรรมฝากยิ้มกลับบ้าน": {
    name: "Send Smiles Home Program",
    description: "A program that distributes dolls to factory workers to take home to their children and grandchildren with the condition that they must smile to their family at least once. This program aims to raise awareness about not forgetting to talk and smile with family to reduce domestic violence rates in the future."
  },

  // กิจกรรมตาต่อตา
  "กิจกรรมตาต่อตา": {
    name: "Eye to Eye Program",
    description: "A program that distributes eyeglasses to elderly people in communities."
  },

  // ธนาคารโอกาส
  "ธนาคารโอกาส": {
    name: "Opportunity Bank",
    description: "A program in collaboration with OVEC (Office of the Vocational Education Commission) to create educational opportunities for children by sending equipment and coordinating with various schools to allow students to attend classes."
  },

  // กิจกรรมถนนครูเดิน
  "กิจกรรมถนนครูเดิน": {
    name: "Teachers Walk the Streets Program",
    description: "A program that drives educational policy initiatives regarding the budget shortage in small schools, highland schools, and remote schools."
  },

  // ส่งของบริจาคให้หน่วยงานและเคสขอความช่วยเหลือทั่วประเทศ
  "ส่งของบริจาคให้หน่วยงานและเคสขอความช่วยเหลือทั่วประเทศ": {
    name: "Donate Items to Organizations and Cases Requesting Help Nationwide",
    description: "A program that sends donated items to organizations and assistance cases across the country."
  }
};

// Helper function to get translated activity data
export const getTranslatedActivity = (activity, language) => {
  if (!activity) return null;

  const lang = language || 'th';

  // If language is Thai or no translation exists, return original
  if (lang === 'th' || !activityTranslations[activity.name]) {
    return {
      name: activity.nameEn || activity.name,
      description: activity.descriptionEn || activity.description,
      location: activity.locationEn || activity.location
    };
  }

  // If English is selected, try to use English fields first, then hardcoded translation, then original
  return {
    name: activity.nameEn || activityTranslations[activity.name]?.name || activity.name,
    description: activity.descriptionEn || activityTranslations[activity.name]?.description || activity.description,
    location: activity.locationEn || activity.location
  };
};
